import React from 'react';
import { useSelector } from 'react-redux';
import { reduxForm, Field, formValues } from 'redux-form';
import Input from '../../components/Input/Input';
import styles from './PropertySearchForm.module.css';
import { getSnippetBySlug } from '../../../helpers/snippets';
import SNIPPETS from '../../../constants/snippets';

function PropertySearchForm({ onSubmit, handleSubmit, search }) {
  const snippets = useSelector((state) => state.snippets.snippets);
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <Field
        placeholder={getSnippetBySlug(
          snippets,
          SNIPPETS.PROPERTIES_PAGE.SEARCH_PLACEHOLDER,
          true
        )}
        type="search"
        name="search"
        onChange={(e) => {
          if (!e.target.value) {
            onSubmit({ search: undefined });
          }
        }}
        component={Input}
      />
      <button disabled={!search} className="button primary-button">
        {getSnippetBySlug(
          snippets,
          SNIPPETS.PROPERTIES_PAGE.SEARCH_BUTTON,
          true
        )}
      </button>
    </form>
  );
}

export default reduxForm({
  form: 'property-search-form',
})(formValues('search')(PropertySearchForm));
